import React from "react";
import { useIntl } from "react-intl";

export default function NationalUniversiade() {
  const intl = useIntl();

  return (
    <>
      <div>{intl.formatMessage({ id: "navbar.nationalUniversiade" })}</div>
    </>
  );
}
